import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=fa81bf88&scoped=true&"
import script from "./ImageUpload.vue?vue&type=script&lang=js&"
export * from "./ImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=fa81bf88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa81bf88",
  null
  
)

export default component.exports